import React from 'react';
import { Dispatch } from 'redux';
import styled from 'styled-components';

import t from '../../../../i18n/t';
import { Column, Row } from '../../../common/layoutUtils';
import { LargeText, RegularText } from '../../../../utils/typography';
import Button from '../../../common/buttons/Button';
import { closeNewEstimateDialog } from '../../../../state/task/actions';
import { updateReadingSource } from '../../../../state/course/actions';
import { secondsToDurationInMinutes } from '../../../../utils/filters';
import { PaceSuggestion } from '@state/task/types';

/** Answers the book's question: Yes makes the pace just read the book's, for all its readings. */
export const answerReadingPace = (dispatch: Dispatch, data: PaceSuggestion, yes: boolean) => {
  if (yes) {
    const { id, name } = data.reading;
    dispatch(updateReadingSource.request({ id, name, secondsPerPage: data.newTimePerPage, courseId: data.courseId }));
  }
  dispatch(closeNewEstimateDialog());
};

type Props = {
  data: PaceSuggestion;
  onAnswer: (yes: boolean) => void;
};

/** "Time per page": asked when a reading's pace was 20% or more off its book's, to use it for the book's readings. */
const ReadingPaceQuestion = ({ data, onAnswer }: Props) => (
  <Content>
    <Title strong>{t.TIME_PER_PAGE}</Title>
    <Row className={'estimate-wrapper'}>
      <Column className={'estimate'}>
        <RegularText>{`${t.PREVIOUS_ESTIMATE}:`}</RegularText>
        <RegularText>{secondsToDurationInMinutes(data.reading.secondsPerPage)}</RegularText>
      </Column>
      <Column className={'estimate'}>
        <RegularText>{`${t.TODAY_AVERAGE}:`}</RegularText>
        <RegularText>{secondsToDurationInMinutes(data.newTimePerPage)}</RegularText>
      </Column>
    </Row>
    <Button filled onClick={() => onAnswer(true)}>
      {t.USE_TODAY_AVG_AS_NEW_EST}
    </Button>
    <Button className={'custom-button'} withoutBorder onClick={() => onAnswer(false)}>
      {t.KEEP_OLD_EST}
    </Button>
  </Content>
);

export default ReadingPaceQuestion;

const Content = styled(Column)`
  width: 100%;
  .estimate-wrapper {
    justify-content: space-between;
    margin-bottom: 25px;
    .estimate {
      align-items: center;
    }
  }
  .custom-button {
    margin-top: 10px;
    background: ${props => `${props.theme.primary}1F`};
  }
`;

const Title = styled(LargeText)`
  margin-top: 0;
  text-align: center;
  display: block;
  margin-bottom: 20px;
`;
